import { useEffect, useState } from "react";
import { ImageOff } from "lucide-react";
import { filesService } from "@/services/companyService";

// Loads a protected image as a blob (sends auth cookie via axios) and renders it.
export function AuthImage({ path, alt = "", className, fallback = null }) {
  const [src, setSrc] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!path) {
      setSrc(null);
      return undefined;
    }
    let active = true;
    let url;
    setFailed(false);
    filesService
      .getBlob(path)
      .then((blob) => {
        if (!active) return;
        url = URL.createObjectURL(blob);
        setSrc(url);
      })
      .catch(() => active && setFailed(true));
    return () => {
      active = false;
      if (url) URL.revokeObjectURL(url);
    };
  }, [path]);

  if (!path || failed) {
    return (
      fallback ?? (
        <div className={className} data-testid="auth-image-fallback">
          <ImageOff className="h-5 w-5 text-muted-foreground" />
        </div>
      )
    );
  }
  if (!src) return <div className={className} />;
  return <img src={src} alt={alt} className={className} />;
}
